/** One aria-live result line for the whole app: every action reports its outcome here ("Queued render #123"). */
import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

type Announce = { message: string; tone: "ok" | "error"; announce: (msg: string, tone?: "ok" | "error") => void };
const Ctx = createContext<Announce>({ message: "", tone: "ok", announce: () => undefined });

export function AnnounceProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<{ message: string; tone: "ok" | "error" }>({ message: "", tone: "ok" });
  const announce = useCallback((message: string, tone: "ok" | "error" = "ok") => setState({ message, tone }), []);
  return <Ctx.Provider value={{ ...state, announce }}>{children}</Ctx.Provider>;
}

export function useAnnounce(): Announce["announce"] {
  return useContext(Ctx).announce;
}

export function ActionResult() {
  const { message, tone } = useContext(Ctx);
  return (
    <div role="status" aria-live="polite" data-testid="action-result" className={`action-result ${tone}`}>
      {message}
    </div>
  );
}
